import { gql } from '@apollo/client';

/**
 * Paginated rows: `pageInfo` omits `totalCount` so the API skips the expensive count (selection-set driven).
 * Use PRIVATE_KEYS_TOTAL_COUNT when you need the total row count.
 */
export const PRIVATE_KEYS_LIST = gql`
  query privateKeysList($args: PrivateKeysInput!) {
    privateKeys(args: $args) {
      pageInfo {
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          filePath
          algorithm
          bitSize
          e
          foundPublicKey
          id
          matchHash
          effectivePermissions
          foundPublicKeyCount
          correlationsCount
          uniqueHash
          fileOffset
          algorithmType
          encapsulationKey
          decapsulationKey
          publicDsaKey
          privateDsaKey
          seed
          currentRemediation {
            privateKey {
              filePath
              matchHash
            }
            status
            description
            author
            createdAt
          }
        }
      }
    }
  }
`;

/** Same `PrivateKeysInput` as the list; selection includes only `pageInfo { totalCount }`. */
export const PRIVATE_KEYS_TOTAL_COUNT = gql`
  query privateKeysTotalCount($args: PrivateKeysInput!) {
    privateKeys(args: $args) {
      pageInfo {
        totalCount
      }
    }
  }
`;

/** Alias of PRIVATE_KEYS_LIST for existing imports and refetchQueries. */
export const GET_PRIVATE_KEY = PRIVATE_KEYS_LIST;

export const PRIVATE_KEY_EXTERNAL_FILTER = gql`
  query privateKeyExternalFilters($args: PrivateKeyExternalFiltersInput!) {
    privateKeyExternalFilters(args: $args) {
      totalClassical
      totalPqc
    }
  }
`;

export const REMEDIATE_PRIVATE_KEYS = gql`
  mutation remediatePrivateKeys($args: RemediatePrivateKeysInput!) {
    remediatePrivateKeys(args: $args) {
      privateKey {
        filePath
        matchHash
      }
      status
      description
      author
      createdAt
      errorMessage
    }
  }
`;
